import SiteTitle from "../../../utils/SiteTitle/SiteTitle";

const DashboardOrgan = () => {
  return (
    <>
      <SiteTitle title="داشبورد" />

      <div className="mt-2">
        <h1 className="text-white">به داشبورد کارباما خوش آمدید</h1>
      </div>
    </>
  );
};

export default DashboardOrgan;
